import { useMapContext } from '@components/map/MapContext';
import { createSensorLayerErrorToast } from '@components/ui/toaster/toaster';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectGroundStationFeatures } from '@redux/situation/monitoring.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { ErrorBoundary } from 'react-error-boundary';
import { Layer, Source } from 'react-map-gl/mapbox';

import { MapIdEnum, SourceNameEnum } from '@/types/map.types';

import { jammingAreaLayer } from './groundStation.layer';

function GroundStationLayerContent() {
  const gcsFeatures = useSelectorWithReplayMode(selectGroundStationFeatures);

  if (!isFeatureCollection(gcsFeatures)) return null;

  return (
    <Source id={SourceNameEnum.GCS_TARGETS} type="geojson" data={gcsFeatures}>
      <Layer {...jammingAreaLayer} />
    </Source>
  );
}

export default function GroundStationLayer() {
  const { mapId } = useMapContext();
  return mapId === MapIdEnum.REPLAY ? (
    <ErrorBoundary fallback={<></>} onError={() => createSensorLayerErrorToast(SourceNameEnum.GCS_TARGETS)}>
      <GroundStationLayerContent />
    </ErrorBoundary>
  ) : (
    <GroundStationLayerContent />
  );
}
